import * as React from "react"
import { Box, Typography } from "@mui/material"
import { formatPrice } from "@ui-seeker/utils"


export default function priceColumn() {
	return {
		name: "actualPrice", label: "Price",
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { currency, listPrice }) => <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
				<Typography variant="body2" sx={{ mr: 2 }}>
					{formatPrice(value, currency)}
				</Typography>
				{ !!listPrice && <Typography variant="body2" sx={{ color: 'text.disabled', textDecoration: 'line-through', fontSize: '0.75rem' }}>
					{formatPrice(listPrice, currency)}
				</Typography> }
			</Box>
		}
	}
}